<app-header></app-header>
<main class="main-content">
    <!------main-content------>
    <!-----------page_title--------------->
    <section class="page_title  pdt_80  pdb_40">
       <div class="container">
          <div class="row">
             <!---------row----------->
             <div class="col-lg-12 col-md-12 text-center">
                <!---------col----------->
                <div class="content_box">
                   <h6>Get in touch</h6>
                   <h1> Contact us directly</h1>
                   <ul class="bread_crumb text-center">
                      <li class="bread_crumb-item"><a href="#">Home</a></li>
                      <li class="bread_crumb-item active">Contact</li>
                   </ul>
                </div>
                <!---------col-end---------->
             </div>
             <!----------row-end---------->
          </div>
       </div>
    </section>
    <!-----------page_title-end--------------> 
    <!-----------footer--------------->
    <section class="contact_page pdb_70 pdt_100">
       <div class="container">
          <div class="row">
             <!---------row----------->
             <div class="col-lg-6 col-md-12">
                <!---------col----------->
                <div class="contact_us_form">
                   <p> If you need answers to your question, feel free to use our contact form below<br class="md_display_none"> and our experts will get back to you immediatly</p>
                   <div class="form_box type_one">
                      <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit(contactUsForm.value)" autocomplete="off">
                         <div class="messages"></div>
                         <div class="controls">
                            <div class="row">
                               <div class="col-lg-6">
                                  <div class="form-group">
                                     <input type="text" class="percent_100 login_input_padding" name="name" placeholder="Your Name" formControlName="name"  
                                     [ngClass]="{ 'is-invalid': submitted &amp;&amp; contactUsForm.controls.name.errors }"
                                     [style.border-color]="submitted &amp;&amp; contactUsForm.controls.name.errors ?'#dc3545' : ''" />
                                     
                                    <div *ngIf="submitted &amp;&amp; contactUsForm.controls.name.errors" class="form-text text-danger">
                                       <div *ngIf="contactUsForm.controls.name.errors.required">Name is required</div>
                                       <div *ngIf="contactUsForm.controls.name.errors.maxlength">Name cannot be more than 45 characters</div> 
                                       <div *ngIf="contactUsForm.controls.name.errors.pattern">Name must contain alphabets</div> 
                                    </div>
                                     <!-- <div class="help-block with-errors"></div> -->
                                  </div>
                               </div>
                               <div class="col-lg-6">
                                  <div class="form-group">
                                     <input type="email" class="percent_100 login_input_padding" name="email" placeholder="Your Email Address" formControlName="email" 
                                     [ngClass]="{ 'is-invalid': submitted &amp;&amp; contactUsForm.controls.email.errors }"
                                     [style.border-color]="submitted &amp;&amp; contactUsForm.controls.email.errors ?'#dc3545' : ''" />
                                     
                                     <div *ngIf="submitted &amp;&amp; contactUsForm.controls.email.errors" class="form-text text-danger">
                                       <div *ngIf="contactUsForm.controls.email.errors.required">Email is required</div>
                                       <div *ngIf="contactUsForm.controls.email.errors.pattern">Please enter a valid email</div> 
                                    </div>
                                     <div class="help-block with-errors"></div>
                                  </div>
                               </div>
                               <div class="col-lg-6">
                                  <div class="form-group">
                                     <input type="text" class="percent_100 login_input_padding" name="phone" placeholder="Your Phone" formControlName="phone"
                                     [ngClass]="{ 'is-invalid': submitted &amp;&amp; contactUsForm.controls.phone.errors }" maxlength="11"
                                     [style.border-color]="submitted &amp;&amp; contactUsForm.controls.phone.errors ?'#dc3545' : ''" />
                                     
                                     <div *ngIf="submitted &amp;&amp; contactUsForm.controls.phone.errors" class="form-text text-danger">
                                       <!-- <div *ngIf="contactUsForm.controls.phone.errors.required">Phone number is required</div>-->
                                       <!-- <div *ngIf="contactUsForm.controls.phone.errors.pattern">Please enter a valid Phone number</div>   -->
                                        <div *ngIf="contactUsForm.controls.phone.errors.required">Phone Number is required</div>
                                        <div *ngIf="contactUsForm.controls.phone.errors.minlength">Phone Number must be at least 7 digit long</div>
                                        <div *ngIf="contactUsForm.controls.phone.errors.maxlength">Phone Number must be at most 13 digit long</div>
                                        <div *ngIf="contactUsForm.controls.phone.errors.pattern">Phone Number must be numbers only</div>
                        
                                    </div>
                                     <div class="help-block with-errors"></div>
                                  </div>
                               </div>
                               <div class="col-lg-6">
                                 <div class="form-group">
                                    <input type="text" class="percent_100 login_input_padding" name="address" placeholder="Address" formControlName="address" 
                                     [ngClass]="{ 'is-invalid': submitted &amp;&amp; contactUsForm.controls.address.errors }"
                                     [style.border-color]="submitted &amp;&amp; contactUsForm.controls.address.errors ?'#dc3545' : ''" />
                                    
                                    <div *ngIf="submitted &amp;&amp; contactUsForm.controls.address.errors" class="form-text text-danger">
                                       <div *ngIf="contactUsForm.controls.address.errors.required">Address is required</div>
                                       <div *ngIf="contactUsForm.controls.address.errors.maxlength">Address cannot be more than 50 characters</div> 
                                       <div *ngIf="contactUsForm.controls.address.errors.pattern">Alphanumeric characters are required</div> 
                                    </div>
                                    <div class="help-block with-errors"></div>
                                 </div>
                              </div>
                               <div class="col-lg-12">
                                  <div class="form-group textarea">
                                     <textarea name="message" class="percent_100 login_input_padding font-12" placeholder="Your Message..." formControlName="message" rows="6" 
                                     [ngClass]="{ 'is-invalid': submitted &amp;&amp; contactUsForm.controls.message.errors }"
                                     [style.border-color]="submitted &amp;&amp; contactUsForm.controls.message.errors ?'#dc3545' : ''" ></textarea>
                                     
                                     <div *ngIf="submitted &amp;&amp; contactUsForm.controls.message.errors" class="form-text text-danger">
                                       <div *ngIf="contactUsForm.controls.message.errors.required">Message is required</div>
                                       <div *ngIf="contactUsForm.controls.message.errors.maxlength">Message cannot be more than 500 characters</div> 
                                       <div *ngIf="contactUsForm.controls.message.errors.pattern">Alphanumeric characters are required</div> 
                                    </div>
                                     <div class="help-block with-errors"></div>
                                  </div>
                               </div>
                           
                               <div class="col-lg-4">
                                  <div class="form-group">
                                     <button class="theme_btn tp_two logo-button-website" type="submit">Submit</button>
                                  </div>
                               </div>
                            </div>
                         </div>
                      </form>
                   </div>
                </div>
                <!---------col-end---------->
             </div>
             <div class="col-lg-6 col-md-12">
                <!---------col----------->
                <div class="contact_us_addres">
                   <div class="emergency_phone">
                      <h6>Emergency phone</h6>
                      <h2> +240 (8) 8234 3555</h2>
                   </div>
                   <ul class="contact_all">
                      <li><a href="#"><span class="linearicons-home4"></span>Street: 9, baderin street. City: Oshodi</a></li>
                      
                      <li><a href="#"><span class="linearicons-telephone"></span>Phone: <small>+240 (8) 8277 9222</small></a></li>
                      <li><a href="#"><span class="linearicons-envelope-open"></span>Email: <small>info@domain.net</small></a></li>
                   </ul>
                   <ul class="social_media">
                      <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                      <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                      <li><a href="#"><i class="fa fa-youtube-play"></i></a></li>
                      <li><a href="#"><i class="fa fa-instagram"></i></a></li>
                      <li><a href="#"><i class="fa fa-vimeo"></i></a></li>
                   </ul>
                   <div class="anouncement">
                      <h5>Announcement:</h5>
                      <p> All the information based on WHO, NHS and CDC website. Information on our website is meant for awareness, if you have any doubt please verify from respective site.</p>
                   </div>
                </div>
                <!---------col-end---------->
             </div>
             <!----------row-end---------->
          </div>
       </div>
    </section>
<app-footer></app-footer>
    
</main>
<app-scrolltotop></app-scrolltotop>
<app-whatsupchat></app-whatsupchat>

